// extracted by mini-css-extract-plugin
export default {"btn":"ShareButton_btn__VATa9","disabled":"ShareButton_disabled__t6MfX"};